import { FunctionComponent } from 'react';
import { PropertyPageMainContent } from '../components/PropertyPageMainContent/PropertyPageMainContent';
import styled from 'styled-components';
import { paletteHelper, SITE_HEADER_HEIGHT_PX } from '@property.com.au/ui-kit';
import { PropertyPageHeader } from '../components/PropertyPageHeader/PropertyPageHeader';
import { useTrackRecentlyViewedProperty } from '../hooks/useTrackRecentlyViewedProperty/useTrackRecentlyViewedProperty';
import { usePropertyId } from '../../contexts/PropertyIdContext/PropertyIdContext';
import { PcaChatModal } from '../components/PcaChatModal/PcaChatModal';
import { PcaChatModalContextProvider } from '../components/PcaChatModal/contexts/PcaChatModalContext';
import { useFeatureRollout } from '@rea-argonaut/experiment';
import { PropertyPageVGDisclaimerFooter } from '../components/PropertyPageVGDisclaimerFooter/PropertyPageVGDisclaimerFooter';
import { PropertySearch } from '../components/PropertySearch/PropertySearch';

const PageContentContainer = styled.main`
  background-color: ${paletteHelper('backgroundSecondaryBase')};
  padding: ${SITE_HEADER_HEIGHT_PX}px 0 0;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const PageBodyContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  /*  Needed so footer is always at the bottom */
  justify-content: space-between;
`;

export const PropertyPageScreen: FunctionComponent<{
  isSignedIn: boolean;
  lockeId?: string;
}> = ({ isSignedIn, lockeId }) => {
  const propertyId = usePropertyId();
  useTrackRecentlyViewedProperty({ isSignedIn, propertyId, lockeId });
  const isPropertyChatEnabled = useFeatureRollout('property_chat').isEnabled();

  return (
    <PageContentContainer>
      <PcaChatModalContextProvider>
        <PageBodyContentContainer>
          <PropertyPageHeader isSignedIn={isSignedIn} />
          <PropertyPageMainContent />
          <PropertyPageVGDisclaimerFooter />
        </PageBodyContentContainer>
        {isSignedIn && isPropertyChatEnabled && <PcaChatModal />}
        <PropertySearch isSignedIn={isSignedIn} />
      </PcaChatModalContextProvider>
    </PageContentContainer>
  );
};
